import { getTotals } from "../selectors"
import { getShippingOptions } from '@ynap/cart-state'

export default function getApplePayRequestSb({ type = 'checkout', orderLevelTaxes, totalsStatus = 'final' }) {
    return (dispatch, getState) => {
        const state = getState()
        const { messages = {}, locale = {}, cart = {}, config = { head: {} } } = state
        const totals = cart?.grandTotal ? getTotals(state, { messages }) : undefined
        const showUsTaxUi = locale?.country === 'US' && config?.head?.flags?.showUsTaxUi
        const applePayConfig = config?.head?.applepay

        const isCheckout = type === 'checkout'
        // Set total and shippingPrice to pending until shipping methods are return and totals re-calculated
        const { lineItems, total } = getApplePayTotalsSb(totals, showUsTaxUi && orderLevelTaxes, messages, totalsStatus)

        const { supportedNetworks, merchantCapabilities } = applePayConfig
        const additionalBasketParams = {
            requiredShippingContactFields: ['postalAddress', 'email', 'phone'],
            requiredBillingContactFields: ['postalAddress', 'email', 'phone'],
            shippingContactEditingMode: "available",
        }

        const availableOptions = getShippingOptions(state, { messages })
        const shippingOptions = availableOptions[0]?.sort((option) => !option.selected).map(({ name, description, finalShippingPrice, id }) => ({
            label: name,
            detail: description.join('/n'),
            amount: finalShippingPrice.match(/-?[0-9]+[\.]*[0-9]*/),
            identifier: id
        }))
        
        return {
            countryCode: locale?.country?.toUpperCase(),
            currencyCode: totals?.currency,
            supportedNetworks,
            merchantCapabilities,
            total,
            ...(lineItems.length > 0 ? { lineItems } : {}),
            ...(!isCheckout && { ...additionalBasketParams }),
            ...(shippingOptions && totalsStatus === 'final' && { shippingOptions })
        }
    }
}

export function getApplePayTotalsSb(totals, showTaxes, messages, type) {
    let lineItems = []
    const { rawPriceWithTax, rawItemTotal, rawTax, rawShippingPrice, rawStoreCredit, rawOrderTaxes } = totals
    const total = { label: messages?.paymentOptionsForm?.applePayBrandLabel(), type, amount: totals?.rawTotal }

    const priceBreakdown = {
        total: { label: messages?.totals?.itemTotal?.(), amount: showTaxes ? rawItemTotal : rawPriceWithTax },
        taxes: { label: messages?.totals?.tax?.(), amount: showTaxes && (rawTax || '0') },
        shippingPrice: { label: messages?.totals?.shipping?.({}), amount: rawShippingPrice },
        storeCredit: { label: messages?.totals?.storeCreditLabel?.(), amount: rawStoreCredit && `-${rawStoreCredit}` },
        customsFees: { label: messages?.totals?.brokerage?.(), amount: rawOrderTaxes?.BROKERAGE_FEE },
    }

    Object.values(priceBreakdown).forEach(({ label, amount }) => {
        if (amount && label) {
            lineItems.push({ label, amount, type })
        }
    })

    lineItems = lineItems.length > 1 ? lineItems : []
    return { lineItems, total }
}
